var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetitioncalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "calendar",
    d: "M6.34375 0C6.84426 0 7.25 0.419733 7.25 0.9375V1.875H21.75V0.9375C21.75 0.419733 22.1557 0 22.6562 0C23.1568 0 23.5625 0.419733 23.5625 0.9375V1.875H25.375C27.377 1.875 29 3.55393 29 5.625V26.25C29 28.3211 27.377 30 25.375 30H3.625C1.62297 30 0 28.3211 0 26.25V5.625C0 3.55393 1.62297 1.875 3.625 1.875H5.4375V0.9375C5.4375 0.419733 5.84324 0 6.34375 0ZM1.8125 7.5V26.25C1.8125 27.2855 2.62398 28.125 3.625 28.125H25.375C26.376 28.125 27.1875 27.2855 27.1875 26.25V7.5H1.8125Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitioncalendar);
export default __webpack_public_path__ + "static/media/Competitioncalendar.a4e1f8f621dfce1ec24fa1806cb8a3f3.svg";
export { ForwardRef as ReactComponent };